export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff90638ad23228026b4fa2bd10f29d1f3cf885c7e&name=fetchTypeahead!'